import { FiTrendingUp, FiCpu, FiShield, FiUsers, FiLayers, FiZap } from "react-icons/fi";
import { LuSettings, LuSmartphone, LuShieldCheck, LuPercent, LuShield, LuUsers, LuCode, LuClipboardList, LuRocket, LuCircleCheck } from "react-icons/lu";

// 1. Hero Block Configuration
export const Web3HeroData = {
  backgroundImage: "/images/serviceBanners/web3Community.webp",
  whiteImage: "/images/serviceBanners/Web3W.webp",
  subTitle: "Web3 Community Building Services",
  title: (
    <>
      Building Stronger <br />
      <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600">Web3 Communities</span>
    </>
  ),
  description:
    "We build strong Web3 communities through structured engagement strategies, governance systems, and scalable ecosystem development to foster trust, improve participation, and drive long term decentralized growth for blockchain projects.",
  primaryButton: {
    title: "Get a Tech Audit",
    onClick: () => console.log("Web3 Audit clicked"),
  },
  secondaryButton: {
    title: "View Our Protocol",
    onClick: () => console.log("Web3 Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "Smart Rewards",
      desc: "Automated reward systems designed to encourage community participation.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Community Automation",
      desc: "Custom Discord and Telegram tools for better engagement management.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Wallet Authentication",
      desc: "Secure token-gated access and wallet-based community experiences.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "DAO Governance",
      desc: "Transparent voting systems built for decentralized decision-making.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/services/website/nodejs.webp",
      top: "16%",
      right: "8%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(168,85,247,0.35)",
      iconGlow: "rgba(168,85,247,0.9)",
    },
  ],
};

// 2. Stats Block
export const web3StatsData = [
  {
    icon: LuSettings,
    value: "150+",
    label: "Apps Built",
    colorClass: "text-[#00d2ff]",
    bgClass: "bg-[#00d2ff]/10",
    borderClass: "border-[#00d2ff]/20",
    glowClass: "shadow-[0_0_20px_rgba(0,210,255,0.15)]",
  },
  {
    icon: LuUsers,
    value: "90+",
    label: "Happy Clients",
    colorClass: "text-[#a855f7]",
    bgClass: "bg-[#a855f7]/10",
    borderClass: "border-[#a855f7]/20",
    glowClass: "shadow-[0_0_20px_rgba(168,85,247,0.15)]",
  },
  {
    icon: LuSmartphone,
    value: "50M+",
    label: "Downloads",
    colorClass: "text-[#06b6d4]",
    bgClass: "bg-[#06b6d4]/10",
    borderClass: "border-[#06b6d4]/20",
    glowClass: "shadow-[0_0_20px_rgba(6,182,212,0.15)]",
  },
  {
    icon: LuShieldCheck,
    value: "99.9%",
    label: "Crash-Free Apps",
    colorClass: "text-[#3b82f6]",
    bgClass: "bg-[#3b82f6]/10",
    borderClass: "border-[#3b82f6]/20",
    glowClass: "shadow-[0_0_20px_rgba(59,130,246,0.15)]",
  },
  {
    icon: LuPercent,
    value: "40%",
    label: "Faster Development",
    colorClass: "text-[#d946ef]",
    bgClass: "bg-[#d946ef]/10",
    borderClass: "border-[#d946ef]/20",
    glowClass: "shadow-[0_0_20px_rgba(217,70,239,0.15)]",
  },
  {
    icon: LuShield,
    value: "100%",
    label: "Client Satisfaction",
    colorClass: "text-[#6366f1]",
    bgClass: "bg-[#6366f1]/10",
    borderClass: "border-[#6366f1]/20",
    glowClass: "shadow-[0_0_20px_rgba(99,102,241,0.15)]",
  },
];

export const web3SolutionsAndProcessData = {
  buildSubtitle: "OUR ECOSYSTEM SOLUTIONS",
  buildTitle: "Scalable Web3 Infrastructure for Community Growth",
  buildCards: [
    {
      title: "Governance Systems",
      desc: "Transparent voting frameworks built for stronger community participation.",
      icon: FiTrendingUp,
      colorClass: "text-[#00d2ff]",
      bgClass: "bg-[#00d2ff]/10",
      borderClass: "border-[#00d2ff]/20 hover:border-[#00d2ff]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(0,210,255,0.25)]",
    },
    {
      title: "Community Automation",
      desc: "Custom bots and moderation tools for active Web3 communities.",
      icon: FiCpu,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "Web3 Access & Identity",
      desc: "Wallet-based authentication and token-gated community access.",
      icon: FiShield,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "Launch Support",
      desc: "Reliable technical systems built to support scalable Web3 launches.",
      icon: FiZap,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "Discord Community Growth",
      desc: "Build and scale active Web3 communities with explicit engagement strategies.",
      icon: FiUsers,
      colorClass: "text-[#34d399]",
      bgClass: "bg-[#34d399]/10",
      borderClass: "border-[#34d399]/20 hover:border-[#34d399]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(52,211,153,0.25)]",
    },
    {
      title: "DAO Engagement Strategy",
      desc: "Improve participation and dynamic interaction within decentralized autonomous organizations.",
      icon: FiLayers,
      colorClass: "text-[#f59e0b]",
      bgClass: "bg-[#f59e0b]/10",
      borderClass: "border-[#f59e0b]/20 hover:border-[#f59e0b]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(245,158,11,0.25)]",
    },
  ],
  processSubtitle: "OUR DEVELOPMENT PROCESS",
  processTitle: "From Community Discovery to Long-Term Growth",
  processSteps: [
    {
      step: "01",
      title: "Discovery & Planning",
      description: "Identify community needs and Web3 ecosystem opportunities.",
      icon: LuUsers,
    },
    {
      step: "02",
      title: "Infrastructure Setup",
      description: "Build custom automation, bots, and engagement systems.",
      icon: LuCode,
    },
    {
      step: "03",
      title: "Governance Launch",
      description: "Deploy transparent voting systems for community participation.",
      icon: LuClipboardList,
    },
    {
      step: "04",
      title: "Community Monitoring",
      description: "Track engagement, performance, and ecosystem stability.",
      icon: LuRocket,
    },
    {
      step: "05",
      title: "Token Utility Design",
      description: "Define token-based incentives to increase user participation profiles safely.",
      icon: LuCircleCheck, // Safe Lucide icon token protecting bundle execution maps from breaking
    },
    {
      step: "06",
      title: "Growth Optimization",
      description: "Improve community reach and ecosystem engagement through deep data insights.",
      icon: LuRocket,
    },
  ],
  benefitsSubtitle: "WHY CHOOSE OUR WEB3 COMMUNITY EXPERTISE",
  benefitsTitle: "Built for Secure & Scalable Web3 Communities",
  benefits: [
    "Web3 governance systems built for transparent participation",
    "Custom moderation and analytics tools for stronger communities",
    "Token-gated access and wallet-based authentication",
    "Smart contract and tokenomics support for ecosystem stability",
    "Community infrastructure designed for long-term scalability",
  ],
  logoImage: "/images/serviceBanners/web3Community.webp",
  whiteLogoImage: "/images/serviceBanners/Web3W.webp",
};

// 4. Portfolio / Results Block
export const web3PortfolioData = {
  subtitle: "OUR ECOSYSTEMS",
  title: "Communities Powered by Tycho",
  buttonText: "Explore Protocols",
  buttonLink: "#all-projects",
  apps: [
    {
      title: "DeFi Hub Alpha",
      badge: "DAO Governance",
      badgeColor: "bg-[#00d2ff]/10 text-[#00d2ff] border-[#00d2ff]/20",
      desc: "Implementing a hybrid governance model with token-gated Discord access for 15k+ holders.",
      downloads: "15k Holders",
      rating: "5.0",
      image: "https://images.unsplash.com/photo-1639762681485-074b7f938ba0?q=80&w=2070&auto=format&fit=crop",
    },
    {
      title: "NFT Syndicate",
      badge: "Launch Infra",
      badgeColor: "bg-[#a855f7]/10 text-[#a855f7] border-[#a855f7]/20",
      desc: "Zero-downtime launch infrastructure during high-volume TGE event.",
      downloads: "0.0s Downtime",
      rating: "4.9",
      image: "https://images.unsplash.com/photo-1527433270404-21b27607b1e7?q=80&w=2070&auto=format&fit=crop",
    },
  ],
};

// 5. Technologies Data
export const web3TechnologiesData = {
  techTitle: "OUR WEB3 STACK",
  technologies: [
    { name: "Solidity/Smart Contracts", icon: "Code" },
    { name: "WalletConnect/SIWE", icon: "Provider" },
    { name: "Snapshot/DAO", icon: "RestAPI" },
    { name: "Subgraph/Indexers", icon: "Database" },
    { name: "Discord/Bot Logic", icon: "Code" },
  ],
  trustTitle: "PROTOCOL PARTNERS",
  trustClients: [
    { image: "/images/logo/google_logo.png", alt: "google_logo" },
    { image: "/images/logo/microsoft_logo.png", alt: "microsoft_logo" },
    { image: "/images/logo/amazon_logo.png", alt: "amazon_logo" },
    { image: "/images/logo/Adobe_Corporate_logo.png", alt: "adobe_logo" },
    { image: "/images/logo/IBM_logo.png", alt: "ibm_logo" },
    { image: "/images/logo/Oracle_logo.png", alt: "oracle_logo" },
  ],
};

// 6. About Block
export const web3AboutData = [
  {
    title: "Web3 Community Building for Long-Term Ecosystem Growth",
    content: (
      <>
        Building a successful Web3 ecosystem requires more than launching a project and expecting engagement. Strong{" "}
        <b className="text-text-primary font-semibold">web3 community building</b> focuses on creating trust, encouraging participation, and maintaining meaningful communication
        between project teams and community members. Communities that feel involved are more likely to stay active during market shifts and ecosystem changes. At{" "}
        <b className="text-text-primary font-semibold">Tycho Technologies</b>, community frameworks are designed around engagement quality, scalability, and long-term
        sustainability to help Web3 projects build stronger digital ecosystems.
      </>
    ),
  },
  {
    title: "Crypto Community Management That Strengthens Trust",
    content: (
      <>
        Growing a decentralized audience takes structured planning and consistent engagement. Effective{" "}
        <b className="text-text-primary font-semibold">crypto community management</b> helps projects maintain active discussions, reduce misinformation, and improve member
        participation across platforms. Communities that receive clear updates and transparent communication often experience stronger retention and healthier engagement levels.
        Businesses exploring <b className="text-text-primary font-semibold">blockchain marketing services</b> increasingly focus on building credibility through active communities
        instead of relying only on short-term promotional campaigns. Tycho Technologies supports brands with practical systems designed for long-term community health.
      </>
    ),
  },
  {
    title: "NFT Community Growth Services for Scalable Adoption",
    content: (
      <>
        Communities play an important role in the adoption of NFT and blockchain-based products. Reliable{" "}
        <b className="text-text-primary font-semibold">nft community growth services</b> help projects attract the right audience while supporting education, trust, and ecosystem
        participation. Projects often achieve better visibility when supported through performance-focused{" "}
        <a href="https://tychotechnologies.com/ppc-paid-advertising-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          ppc advertising services
        </a>{" "}
        that bring qualified users into growing ecosystems without sacrificing community quality.
      </>
    ),
  },
  {
    title: "Why Businesses Choose a Web3 Marketing Agency India",
    content: (
      <>
        The demand for a trusted <b className="text-text-primary font-semibold">web3 marketing agency india</b> continues to grow as blockchain businesses seek sustainable ways to
        improve engagement and ecosystem growth. Brands investing in <b className="text-text-primary font-semibold">blockchain community management india</b> often look for
        structured strategies that improve participation and strengthen user trust. Businesses working with Tycho Technologies benefit from practical Web3 support systems designed
        around measurable engagement. Many organizations also combine ecosystem growth efforts with{" "}
        <a href="https://tychotechnologies.com/email-automation-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          email automation services
        </a>{" "}
        to maintain stronger communication and long-term community relationships.
      </>
    ),
  },
];

// 7. FAQs
export const web3FaqData = [
  {
    q: "Can you integrate with existing Discord servers?",
    a: "Yes, our bots are designed to integrate seamlessly with existing communities without disrupting the current flow.",
  },
  {
    q: "Is the governance on-chain or off-chain?",
    a: "We support both. We can implement full on-chain voting or hybrid snapshots depending on your gas fee preferences.",
  },
];
